import { getConfig } from "../config";
import type { BannerPromotion } from "../types";

export interface FetchPromotionResult {
  success: boolean;
  promotion?: BannerPromotion;
  error?: string;
}

export async function fetchPromotion(): Promise<FetchPromotionResult> {
  const { apiBaseUrl, projectId } = getConfig();

  try {
    const url = new URL(
      `${apiBaseUrl}/public/marketing/promotions`,
    );
    url.searchParams.set("projectId", projectId);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      return {
        success: false,
        error:
          (body as { message?: string }).message ||
          `Request failed with status ${response.status}`,
      };
    }

    const json = await response.json();
    const promotion = Array.isArray(json) && json.length > 0 ? json[0] : json;

    if (!promotion || (Array.isArray(json) && json.length === 0)) {
      return { success: false, error: "No promotions available" };
    }

    return { success: true, promotion: promotion as BannerPromotion };
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : "Unknown error",
    };
  }
}
